import React, { forwardRef, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import API from '../../API';
import { GradeLevelName } from '../../Utils/Function';
import parse from 'html-react-parser';
import ProjectContent from './ProjectContent';
import '../../App.css';

const ApplicantContent = forwardRef((props, ref) => {
    const RedirectTo = useNavigate()
    const [_AnnounceContent, setAnnounceContent] = useState([]);
    useEffect(() => {
        (async () => {
            _Announce();
        })();

        return () => { }
    }, []);
    const _Announce = async () => {
        setAnnounceContent([]);
        API({ method: "get", url: "/News/Last" }).then(res => {
            setAnnounceContent(res.data);
        }).catch(error => {

        });
    }

    const _MemberLogout = async () => {

        Swal.fire({
            icon: 'warning',
            title: 'ต้องการออกจากระบบหรือไม่ ?',
            text: '',
            showCancelButton: true,
            confirmButtonText: 'ตกลง',
            confirmButtonColor: '#d33',
            cancelButtonText: 'ยกเลิก'
        }).then((r) => {
            if (!r.isConfirmed) {
                return;
            }
            Swal.isLoading();
            API({ method: "delete", url: "/Authorization/Logout" }).then(res => {
                if (res.data.Status) {
                    sessionStorage.setItem('Authorization', null);
                    sessionStorage.setItem("MemberID", null);
                    sessionStorage.setItem("Name", null);
                    sessionStorage.setItem("Mobile", null);
                    sessionStorage.setItem("GradeLevel", null);
                    sessionStorage.setItem("UserType", null);
                    sessionStorage.clear();
                    window.location.reload();
                    Swal.close();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message,
                    });
                }
            }).catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: (error.response != undefined ? error.response.data.Message : 'การเชื่อมต่อผิดพลาด'),
                    text: error.message + ' [' + error.code + ']',
                });
            });
        });
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 mt-2'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <div className='card-title fs-5 fw-semibold'>ข้อมูลผู้ลงทะเบียน</div>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className="mb-2">
                                                    <label className="form-label fw-semibold">ชื่อ</label>
                                                    <input type="text" readOnly className="form-control-plaintext text-end" value={sessionStorage.getItem('Name')} />
                                                </div>
                                                <div className="mb-3">
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold">หมายเลขโทรศัพท์มือถือ</label>
                                                    <input type="text" readOnly className="form-control-plaintext text-end" value={sessionStorage.getItem('Mobile')} />
                                                </div>
                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold">ระดับชั้น</label>
                                                    <input type="text" readOnly className="form-control-plaintext text-end" value={(sessionStorage.getItem('GradeLevel') != null ? GradeLevelName(sessionStorage.getItem('GradeLevel')) : '-')} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-12 text-end'>
                                                <button type='button' className='btn btn-danger btn-lg' style={{ width: '150px' }} onClick={() => { _MemberLogout() }}>ออกจากระบบ</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-10 mt-2'>
                        <div className='row mb-4'>
                            <div className='col-12'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <div className='card-title fs-5 fw-semibold'>ระเบียบการและใบสมัคร</div>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row mb-2'>
                                            <div className='col-12 text-center'>
                                                <a href="https://wreg-69.s3.ap-southeast-7.amazonaws.com/manual.pdf" target='_blank'>
                                                    <img src="https://wreg-69.s3.ap-southeast-7.amazonaws.com/manualBaner.jpg" style={{ "maxWidth": "90%" }} />
                                                </a>
                                            </div>
                                        </div>
                                        <ProjectContent />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-4'>
                            <div className='col-12'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <div className='card-title fs-5 fw-semibold'> ข่าวประชาสัมพันธ์</div>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row mt-2 mb-2'>
                                            {_AnnounceContent.map((item, index) => (
                                                <div key={index} className='row mt-2 mb-2'>
                                                    <div className='col-12'>
                                                        {parse(item.Content)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
});
export default React.memo(ApplicantContent)